/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : policyReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

const initialState = {
  error: false,
  msg: "",
  policies: [],
  domains: [],
  actions: [],
};
const policyReducer = (state = initialState, action) => {
  console.log("Policy Reducer:", action);
  console.log("Policy State:", state);
  switch (action.type) {
    case actionType.ADD_POLICIES:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.GET_POLICIES:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        policies: action.payload,
      };
    case actionType.GET_ACTIONS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        actions: action.payload,
      };

    case actionType.UPDATE_POLICIES:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.DELETE_POLICIES:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.GET_DOMAINS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        domains: action.payload,
      };

    default:
      return state;
  }
};

export default policyReducer;
